import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';
import { ITrackingObject, TrackingObjectNamesEnum } from '../../tracking.data';

export const TRACKING_STATEMENT_SCHEMA = Object.freeze({
  CLIENT_ID: '',
  STATEMENT_VIEW_ID: '',
  DATE_RANGE_START: '',
  DATE_RANGE_END: '',
  DOCUMENT_ID_ARRAY: [],
  REVISION_ID_ARRAY: [],
});
const RECORD = generateSchema(TRACKING_STATEMENT_SCHEMA);
const KEYS: any = generateKeys(TRACKING_STATEMENT_SCHEMA);

export class StatementTrackingObject
  extends Record(RECORD)
  implements ITrackingObject {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingObjectNamesEnum.statement;
  }

  get properties() {
    return this.toJS();
  }
}
